
if(!customElements.get("video-wrapper")) {
  class VideoWrapper extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector('video');
      this.button = this.querySelector('button[data-toggle-play]');
    }

    connectedCallback() {
      this.button.addEventListener('click', this.togglePlayPause.bind(this));
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.togglePlayPause);
    }

    togglePlayPause() {
      if (this.video.paused) {
        this.video.play();
        this.button.classList.remove('is-paused');
      } else {
        this.button.classList.add('is-paused');
        this.video.pause();
      }
    }
  }

  customElements.define("video-wrapper", VideoWrapper);
}
